var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-1 px-3 lighten-3 rounded-pill text-no-wrap",class:_vm.color,staticStyle:{"width":"fit-content"}},[_vm._v(" "+_vm._s(_vm._f("priceDisplay")(_vm.price))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }